import { ApiError, getApiErrorRecord } from './api-request-error';
export var ErrorType;
(function (ErrorType) {
    /**
     * API httpCode 非 200
     */
    ErrorType["ApiError"] = "ApiError";
    /**
     * API httpCode 200，业务 Code 存在异常
     */
    ErrorType["ApiBizError"] = "ApiBizError";
    /**
     * 未归类的错误
     */
    ErrorType["Unknown"] = "Unknown";
})(ErrorType || (ErrorType = {}));
export const getErrorType = (error) => {
    var _a;
    if (!error) {
        return ErrorType.Unknown;
    }
    if (error instanceof ApiError) {
        // 优先用业务给的 api error type
        if ((_a = error.errorOption) === null || _a === void 0 ? void 0 : _a.errorType) {
            return error.errorOption.errorType;
        }
        return ErrorType.ApiError;
    }
    return ErrorType.Unknown;
};
export const getErrorRecord = (error) => {
    if (!error) {
        return {};
    }
    return Object.assign(Object.assign({}, getApiErrorRecord(error)), { message: error.message, stack: error.stack, type: getErrorType(error) });
};
